import { ContentHeaderType } from './type'
import Visual from './Visual'

const ContentHeader = ({ content, title }: ContentHeaderType) => {
  return <Visual content={content} title={title} />
}

export default ContentHeader
